export const useStyles = () => {

  return {
    container: {
      width: '100%',
      height: '100%',
      paddingRight: '50px',
      paddingLeft: '30px',
      paddingTop: '50px',
      paddingBottom: '20px',
      overflowY: 'auto',
      overflowX: 'hidden',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      gap: 1
    },
    title: {
      color: "#4A01C4",
      fontWeight: 600,
      fontSize: "1.5rem",
      mb: 2
    }
  }

}